class TpBackToTop {
    /**
     * Initializes the back to top component by setting up an event listener for the window's scroll event.
     * When the window is scrolled, it will check if the scroll position is greater than 50.
     * If it is, it will display the back to top element. Otherwise, it will hide it.
     */
    constructor() {
        window.addEventListener('scroll', e => {
            if (window.scrollY > 50) {
                this._display();

                return;
            }

            this._hide();
        });

        if (window.scrollY > 50) {
            this._display();
        }
    }

    /**
     * Displays the back to top element.
     *
     * This function sets the display CSS property of the back to top element to "flex",
     * which makes it visible.
     */
    _display() {
        document.querySelector(".scroll-top").style.display = "flex";
    }

    /**
     * Hides the back to top element.
     *
     * This function sets the display CSS property of the back to top element to "none",
     * which makes it invisible.
     */
    _hide() {
        document.querySelector(".scroll-top").style.display = "none";
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new TpBackToTop();
});
